export const returnsWhitelistKeys = {
  marketplaceId: true, // not on swagger
  items: true, // not on swagger
  calculateInsuranceValue: true, // not on swagger
  rate: true, // not on swagger
  packingSlipTemplateId: true, // not on swagger
  shipmentEmailNotificationTemplateId: true, // not on swagger
  deliveryEmailNotificationTemplateId: true, // not on swagger
  shippingConfigurationHash: true, // <-- not on swagger
  carrierId: true, // <-- not on swagger
};

export const returnsFalsyChecksOk = (key, contextValue, reduxValue) => {
  const nullIsOkForUndefined = {
    customs: true,
    serviceCollectionGuid: true,
    shipDate: true,
  };
  if (nullIsOkForUndefined[key] && contextValue === null && reduxValue === undefined) {
    return true;
  }
  if (key === 'availableShippingOptions' && contextValue && !reduxValue) {
    return true;
  }
  return false;
};
